import { ToastProvider } from "@circle-react-uikit/ToastV2";
import { PaywallSubscriptionsAdmin } from "./PaywallSubscriptionsAdmin";

export const PaywallSubscriptionsAdminIndex = () => (
  <ToastProvider>
    <PaywallSubscriptionsAdmin />
  </ToastProvider>
);
